webpackJsonp([28],{

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RETURN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_YH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_NMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_RC; });
var RETURN_URL = 'https://hotel.sunacctg.com/pc',
    LOGIN_URL = 'https://hotel.sunacctg.com/auth',
    IS_YH = true,
    IS_NMG = false,
    IS_RC = false;

var href = window.location;
switch (href.host) {
	case '127.0.0.1:8090':
		RETURN_URL = 'http://127.0.0.1:8090', LOGIN_URL = 'http://testcem1.mgit365.com:8020/auth', IS_YH = true, IS_NMG = false, IS_RC = false;
		break;
	case '47.95.130.146:8090':
		//融创测试环境
		RETURN_URL = 'http://47.95.130.146:8090/pc', LOGIN_URL = 'http://47.95.130.146:8090/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
	case '39.97.129.132:8080':
		RETURN_URL = 'http://39.97.129.132:8080/pc', LOGIN_URL = 'http://39.97.129.132:8080/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
	case 'testcem1.mgit365.com':
		RETURN_URL = 'http://testcem1.mgit365.com/pc', LOGIN_URL = 'http://testcem1.mgit365.com/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
	case 'testcem1.mgit365.com:8020':
		//粤海测试环境
		RETURN_URL = 'http://testcem1.mgit365.com:8020/pc', LOGIN_URL = 'http://testcem1.mgit365.com:8020/auth', IS_YH = true, IS_NMG = false, IS_RC = false;
		break;
	case 'hotel.sunacctg.com':
		//融创生产老地址
		RETURN_URL = 'https://hotel.sunacctg.com/pc', LOGIN_URL = 'https://hotel.sunacctg.com/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
	case 'www.sunachotels.com.cn':
		//融创生产新地址
		RETURN_URL = 'https://www.sunachotels.com.cn/pc', LOGIN_URL = 'https://www.sunachotels.com.cn/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
	case 'booking.gdhhotels.com':
		//粤海生产
		RETURN_URL = 'http://booking.gdhhotels.com/pc', LOGIN_URL = 'http://booking.gdhhotels.com/auth', IS_YH = true, IS_NMG = false, IS_RC = false;
		break;
	case 'www.gdhhotels.com':
		//品宣粤海生产
		RETURN_URL = 'http://www.gdhhotels.com/pc', LOGIN_URL = 'http://www.gdhhotels.com/auth', IS_YH = true, IS_NMG = false, IS_RC = false;
		break;
	default:
		RETURN_URL = 'http://testcem1.mgit365.com/pc', LOGIN_URL = 'http://testcem1.mgit365.com/auth', IS_YH = false, IS_NMG = false, IS_RC = true;
		break;
}


/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_axios__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_Constants__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_DataFilter__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_VueFilter__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_transitions_collapse_transition__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_transitions_collapse_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_base_css__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_css_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_main_css__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_font_iconfont_css__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_font_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_font_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jsencrypt__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_polyfill__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_index__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__theme_yh_index_css__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__theme_yh_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__theme_yh_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














 /*引入公共样式*/
 /*引入公共样式*/





// import '../theme/index.css'  //融创主题色
 //粤海主题色

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
	locale: localStorage.lang || 'zh',
	messages: {
		'zh': __webpack_require__(289),
		'en': __webpack_require__(288)
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_transitions_collapse_transition___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$jsEncrypt = __WEBPACK_IMPORTED_MODULE_17_jsencrypt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_4__assets_js_axios__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.C = __WEBPACK_IMPORTED_MODULE_5__assets_js_Constants__;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ReturnUrl = __WEBPACK_IMPORTED_MODULE_19__config_index__["a" /* RETURN_URL */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$LoginUrl = __WEBPACK_IMPORTED_MODULE_19__config_index__["b" /* LOGIN_URL */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isYH = __WEBPACK_IMPORTED_MODULE_19__config_index__["c" /* IS_YH */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isNMG = __WEBPACK_IMPORTED_MODULE_19__config_index__["d" /* IS_NMG */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isRC = __WEBPACK_IMPORTED_MODULE_19__config_index__["e" /* IS_RC */];

for (var k in __WEBPACK_IMPORTED_MODULE_6__assets_js_DataFilter__["a" /* default */]) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(k, __WEBPACK_IMPORTED_MODULE_6__assets_js_DataFilter__["a" /* default */][k]);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$token = {
	headers: {
		'accessToken': localStorage.accessToken,
		'userToken': localStorage.userToken
	}
};

//融创百度统计
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
	var hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?ebbe9069a11c96701e8a5b7802849511";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	i18n: i18n,
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(287);


var WEEK_ARR = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
/* harmony default export */ __webpack_exports__["a"] = ({
	minutefmt: function minutefmt(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'mm:ss';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	timefmt: function timefmt(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'HH:mm:ss';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	datefmt: function datefmt(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy-MM-dd';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	datefmt1: function datefmt1(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'MM月dd日';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	datefmt2: function datefmt2(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy年MM月dd日';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	datefmt3: function datefmt3(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyyMMdd';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	datefmt4: function datefmt4(value) {
		if (value == null) {
			return;
		}
		var d = new Date(value.replace(/-/g, '/'));
		var year = d.getFullYear();
		var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1);
		var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
		return year + "年" + month + "月" + day + "日";
	},
	datetimefmt: function datetimefmt(value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy-MM-dd HH:mm:ss';
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* DateUtil */].formatDate(d, fmt);
			}
		}
		return '';
	},
	weekfmt: function weekfmt(value) {
		if (value) {
			// var v = value - 0;
			var d = new Date(value);
			if (d.getTime()) {
				var day = d.getDay();
				return WEEK_ARR[day] || '';
			}
		}
		return '';
	},
	pricefmt: function pricefmt(value) {
		if (value === null || value === '' || value === undefined || isNaN(value)) {
			return 0;
		}
		return value / 100;
	},
	textSub: function textSub(value, maxlen) {
		if (value) {
			maxlen = maxlen || 20;
			if (value.length <= maxlen) {
				return value;
			} else {
				return value.substring(0, maxlen) + '...';
			}
		}
		return '';
	},
	dateSub: function dateSub(value) {
		return value.substring(0, 10);
	},
	dateSub1: function dateSub1(value, minlen, maxlen) {
		if (value == undefined) {
			return;
		}
		return value.substring(minlen, maxlen);
	},
	MoneyFormat: function MoneyFormat(money) {
		if (money && money != null && Number(money) > 0) {
			money = String(money);
			var left = money.split('.')[0],
			    right = money.split('.')[1];
			right = right ? right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0' : '.00';
			var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
			return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
		} else if (money == 0) {
			// 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
			return '0.00';
		} else {
			return '';
		}
	},
	money: function money(value, sub) {
		//sub=0,1
		return value.split('.')[sub];
	}
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderYH_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderYH_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_HeaderYH_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_FooterYH_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_FooterYH_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_FooterYH_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//

// 粤海头尾



// 融创头尾
// import Header from "./components/common/HeaderRC.vue"
// import Footer from "./components/common/FooterRC.vue"




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {
			headerShow: true
		};
	},
	created: function created() {
		//		    this.getAccessToken();
	},
	mounted: function mounted() {
		// if(!sessionStorage.a){
		//     this.clearCookie()
		//     this.clearCookie1()
		// 	sessionStorage.a = "a"
		// }
	},

	methods: {
		clearCookie: function clearCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + "; path=/";
				}
			}
		},
		clearCookie1: function clearCookie1() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
				}
			}
		},
		getAccessToken: function getAccessToken() {
			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/gu/api/v1/hub/auth/getAccessToken").then(function (res) {
				localStorage.accessToken = res.data.data.accessToken;
				__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$token = {
					headers: {
						'accessToken': res.data.data.accessToken,
						'userToken': localStorage.userToken
					}
				};
			}).catch(function (error) {
				console.log(error);
			});
		}
	},
	components: {
		Header: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderYH_vue___default.a,
		Footer: __WEBPACK_IMPORTED_MODULE_1__components_common_FooterYH_vue___default.a
	},
	watch: {
		$route: function $route(to, from) {
			if (this.$route.path === "/questions" || this.$route.path === "/time-out" || this.$route.path === "/answer-success" || this.$route.path === "/invalid") {
				// 例，问卷路径
				this.headerShow = false;
			} else {
				this.headerShow = true;
			}
		}
	}
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: "FooterYH",
	data: function data() {
		return {
			hotelList: [],
			hostUrl: ""
		};
	},
	created: function created() {
		this.hostUrl = window.location.protocol + '//' + window.location.host;
		this.getHotelList();
	},

	methods: {
		getHotelList: function getHotelList() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/gk/hotel/service/queryHotelList", {}, this.$token).then(function (res) {
				if (res.data.status == 200) {
					var hotelArr = res.data.data;
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(hotelArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var x = _step.value;

							if (x.hotelInfoList && x.hotelInfoList.length > 0) {
								var _iteratorNormalCompletion2 = true;
								var _didIteratorError2 = false;
								var _iteratorError2 = undefined;

								try {
									for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(x.hotelInfoList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
										var y = _step2.value;

										_this.hotelList.push(y);
									}
								} catch (err) {
									_didIteratorError2 = true;
									_iteratorError2 = err;
								} finally {
									try {
										if (!_iteratorNormalCompletion2 && _iterator2.return) {
											_iterator2.return();
										}
									} finally {
										if (_didIteratorError2) {
											throw _iteratorError2;
										}
									}
								}
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				} else {
					_this.$message.error(res.data.message);
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			memberCenter: this.$LoginUrl + '?url=' + this.$ReturnUrl + '/jump-page',
			mobileReg: /^0?(13[0-9]|15[012356789]|17[012356789]|18[0-9]|14[57]|19[9])[0-9]{8}$/, //手机号验证
			urlReg: /^\/pc/,
			showLanguage: false
		};
	},

	methods: {
		login: function login() {
			location.href = this.$LoginUrl + "?url=" + this.$ReturnUrl + "/jump-page";
		},
		toMemberCenter: function toMemberCenter() {
			window.location.href = this.$LoginUrl + '?url=' + this.$ReturnUrl + '/jump-page';
		},
		searchHotel: function searchHotel() {
			this.$router.push('/search-hotel');
		},
		ZNurl: function ZNurl() {
			window.location.reload();
		},
		ENurl: function ENurl() {
			var url = window.location.pathname;
			if (this.urlReg.test(url)) {
				url = url.substring(3);
				if (window.location.search) {
					window.location.href = "http://" + window.location.host + "/enpc" + url + window.location.search;
				} else {
					window.location.href = "http://" + window.location.host + "/enpc" + url;
				}
			} else {
				window.location.reload();
			}
		}
	}
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COURSE_TYPE_BANNER", function() { return COURSE_TYPE_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COURSE_TYPE_DESC", function() { return COURSE_TYPE_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COURSE_META_TEXT", function() { return COURSE_META_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COURSE_META_IMG", function() { return COURSE_META_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COURSE_META_VIDEO", function() { return COURSE_META_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORDER_STATUS", function() { return ORDER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORDER_STATUS_MAP", function() { return ORDER_STATUS_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMENT_TYPE", function() { return COMMENT_TYPE; });
var COURSE_TYPE_BANNER = '1'; //banner
var COURSE_TYPE_DESC = '2'; //description


var COURSE_META_TEXT = 'text';
var COURSE_META_IMG = 'image';
var COURSE_META_VIDEO = 'video';

//0待付款；1已付款；2已签到；3退款中；4交易完成；5交易关闭 ,
var ORDER_STATUS = {
	'WAITPAY': '0',
	'PAY': '1',
	'SIGNED': '2',
	'REFUND': '3',
	'FINISH': '4',
	'CLOSE': '5'
};
var ORDER_STATUS_MAP = {
	'0': '待付款',
	'1': '待消费',
	'2': '已签到',
	'3': '退款中',
	'4': '交易完成',
	'5': '交易关闭'
};
var COMMENT_TYPE = {
	NICE: '3',
	MIDDLE: '2',
	BAD: '1'
};

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);



/**
 * Created by YECHENGYOU on 2018/11/8.
 */
/**
 * 字符串的第一个字母大写
 */


__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('capitalize', function (value) {
	if (!value && value !== 0) return '';
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
});

/**
 * 将字符串全部转为大写字母
 */
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('uppercase', function (value) {
	return value || value === 0 ? value.toString().toUpperCase() : '';
});

/**
 * 将字符串全部转为小写字母
 */
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('uppercase', function (value) {
	return value || value === 0 ? value.toString().toLowerCase() : '';
});

/**
 * 12345 => $12,345.00
 *
 * @param {String} sign
 * @param {Number} decimals Decimal places
 */

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('currency', function (value, _currency, decimals) {
	value = parseFloat(value);
	if (!isFinite(value) || !value && value !== 0) return '';
	_currency = _currency != null ? _currency : '$';
	decimals = decimals != null ? decimals : 2;
	var stringified = Math.abs(value).toFixed(decimals);
	var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	var i = _int.length % 3;
	var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
	var _float = decimals ? stringified.slice(-1 - decimals) : '';
	var sign = value < 0 ? '-' : '';
	var digitsRE = /(\d{3})(?=\d)/g;
	return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
});

/**
 * 'item' => 'items'
 *
 * @params
 *  an array of strings corresponding to
 *  the single, double, triple ... forms of the word to
 *  be pluralized. When the number to be pluralized
 *  exceeds the length of the args, it will use the last
 *  entry in the array.
 *
 *  e.g. ['single', 'double', 'triple', 'multiple']
 */

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('pluralize', function (value) {
	var args = toArray(arguments, 1);
	return args.length > 1 ? args[value % 10 - 1] || args[args.length - 1] : args[0] + (value === 1 ? '' : 's');
});

/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
	offset = offset ? parseInt(offset, 10) : 0;
	n = toNumber(n);
	return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/**
 * Filter filter for arrays
 *
 * @param {String} search
 * @param {String} [delimiter]
 * @param {String} ...dataKeys
 */

function filterBy(arr, search, delimiter) {
	arr = convertArray(arr);
	if (search == null) {
		return arr;
	}
	if (typeof search === 'function') {
		return arr.filter(search);
	}
	// cast to lowercase string
	search = ('' + search).toLowerCase();
	// allow optional `in` delimiter
	// because why not
	var n = delimiter === 'in' ? 3 : 2;
	// extract and flatten keys
	var keys = Array.prototype.concat.apply([], toArray(arguments, n));
	var res = [];
	var item, key, val, j;
	for (var i = 0, l = arr.length; i < l; i++) {
		item = arr[i];
		val = item && item.$value || item;
		j = keys.length;
		if (j) {
			while (j--) {
				key = keys[j];
				if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
					res.push(item);
					break;
				}
			}
		} else if (contains(item, search)) {
			res.push(item);
		}
	}
	return res;
};

/**
 * 排序
 */
function orderBy(arr) {
	var _comparator = null;
	var sortKeys = undefined;
	arr = convertArray(arr);

	// determine order (last argument)
	var args = toArray(arguments, 1);
	var order = args[args.length - 1];
	if (typeof order === 'number') {
		order = order < 0 ? -1 : 1;
		args = args.length > 1 ? args.slice(0, -1) : args;
	} else {
		order = 1;
	}

	// determine sortKeys & comparator
	var firstArg = args[0];
	if (!firstArg) {
		return arr;
	} else if (typeof firstArg === 'function') {
		// custom comparator
		_comparator = function comparator(a, b) {
			return firstArg(a, b) * order;
		};
	} else {
		// string keys. flatten first
		sortKeys = Array.prototype.concat.apply([], args);
		_comparator = function comparator(a, b, i) {
			i = i || 0;
			return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || _comparator(a, b, i + 1);
		};
	}

	function baseCompare(a, b, sortKeyIndex) {
		var sortKey = sortKeys[sortKeyIndex];
		if (sortKey) {
			if (sortKey !== '$key') {
				if (isObject(a) && '$value' in a) a = a.$value;
				if (isObject(b) && '$value' in b) b = b.$value;
			}
			a = isObject(a) ? getPath(a, sortKey) : a;
			b = isObject(b) ? getPath(b, sortKey) : b;
		}
		return a === b ? 0 : a > b ? order : -order;
	}

	// sort on a copy to avoid mutating original array
	return arr.slice().sort(_comparator);
};

/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
	start = start || 0;
	var i = list.length - start;
	var ret = new Array(i);
	while (i--) {
		ret[i] = list[i + start];
	}
	return ret;
}

function convertArray(value) {
	if (Array.isArray(value)) {
		return value;
	} else if (isPlainObject(value)) {
		// convert plain object to array.
		var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(value);
		var i = keys.length;
		var res = new Array(i);
		var key;
		while (i--) {
			key = keys[i];
			res[i] = {
				$key: key,
				$value: value[key]
			};
		}
		return res;
	} else {
		if (typeof value === 'number' && !isNaN(value)) {
			value = range(value);
		}
		return value || [];
	}
}

/**
 * String contain helper
 *
 * @param {*} val
 * @param {String} search
 */

function contains(val, search) {
	var i;
	if (isPlainObject(val)) {
		var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(val);
		i = keys.length;
		while (i--) {
			if (contains(val[keys[i]], search)) {
				return true;
			}
		}
	} else if (Array.isArray(val)) {
		i = val.length;
		while (i--) {
			if (contains(val[i], search)) {
				return true;
			}
		}
	} else if (val != null) {
		return val.toString().toLowerCase().indexOf(search) > -1;
	}
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
	return obj !== null && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object';
}

function isPlainObject(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * Check and convert possible numeric strings to numbers
 * before setting back to data
 *
 * @param {*} value
 * @return {*|Number}
 */

function toNumber(value) {
	if (typeof value !== 'string') {
		return value;
	} else {
		var parsed = Number(value);
		return isNaN(parsed) ? value : parsed;
	}
}

function getPath(obj, path) {
	return parseExpression(path).get(obj);
}

/**
 * Parse an expression into re-written getter/setters.
 *
 * @param {String} exp
 * @param {Boolean} needSet
 * @return {Function}
 */

var expressionCache = new Cache(1000);
var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
var booleanLiteralRE = /^(?:true|false)$/;

function parseExpression(exp, needSet) {
	exp = exp.trim();
	// try cache
	var hit = expressionCache.get(exp);
	if (hit) {
		if (needSet && !hit.set) {
			hit.set = compileSetter(hit.exp);
		}
		return hit;
	}
	var res = { exp: exp };
	res.get = isSimplePath(exp) && exp.indexOf('[') < 0
	// optimized super simple getter
	? makeGetterFn('scope.' + exp)
	// dynamic getter
	: compileGetter(exp);
	if (needSet) {
		res.set = compileSetter(exp);
	}
	expressionCache.put(exp, res);
	return res;
}

function Cache(limit) {
	this.size = 0;
	this.limit = limit;
	this.head = this.tail = undefined;
	this._keymap = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
}

var p = Cache.prototype;

/**
 * Put <value> into the cache associated with <key>.
 * Returns the entry which was removed to make room for
 * the new entry. Otherwise undefined is returned.
 * (i.e. if there was enough room already).
 *
 * @param {String} key
 * @param {*} value
 * @return {Entry|undefined}
 */

p.put = function (key, value) {
	var removed;
	if (this.size === this.limit) {
		removed = this.shift();
	}

	var entry = this.get(key, true);
	if (!entry) {
		entry = {
			key: key
		};
		this._keymap[key] = entry;
		if (this.tail) {
			this.tail.newer = entry;
			entry.older = this.tail;
		} else {
			this.head = entry;
		}
		this.tail = entry;
		this.size++;
	}
	entry.value = value;

	return removed;
};

/**
 * Purge the least recently used (oldest) entry from the
 * cache. Returns the removed entry or undefined if the
 * cache was empty.
 */

p.shift = function () {
	var entry = this.head;
	if (entry) {
		this.head = this.head.newer;
		this.head.older = undefined;
		entry.newer = entry.older = undefined;
		this._keymap[entry.key] = undefined;
		this.size--;
	}
	return entry;
};

/**
 * Get and register recent use of <key>. Returns the value
 * associated with <key> or undefined if not in cache.
 *
 * @param {String} key
 * @param {Boolean} returnEntry
 * @return {Entry|*}
 */

p.get = function (key, returnEntry) {
	var entry = this._keymap[key];
	if (entry === undefined) return;
	if (entry === this.tail) {
		return returnEntry ? entry : entry.value;
	}
	// HEAD--------------TAIL
	//   <.older   .newer>
	//  <--- add direction --
	//   A  B  C  <D>  E
	if (entry.newer) {
		if (entry === this.head) {
			this.head = entry.newer;
		}
		entry.newer.older = entry.older; // C <-- E.
	}
	if (entry.older) {
		entry.older.newer = entry.newer; // C. --> E
	}
	entry.newer = undefined; // D --x
	entry.older = this.tail; // D. --> E
	if (this.tail) {
		this.tail.newer = entry; // E. <-- D
	}
	this.tail = entry;
	return returnEntry ? entry : entry.value;
};

function isSimplePath(exp) {
	return pathTestRE.test(exp) &&
	// don't treat true/false as paths
	!booleanLiteralRE.test(exp) &&
	// Math constants e.g. Math.PI, Math.E etc.
	exp.slice(0, 5) !== 'Math.';
}

function makeGetterFn(body) {
	try {
		/* eslint-disable no-new-func */
		return new Function('scope', 'return ' + body + ';');
		/* eslint-enable no-new-func */
	} catch (e) {
		'development' !== 'production' && warn('Invalid expression. ' + 'Generated function body: ' + body);
	}
}

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_index__ = __webpack_require__(163);


// import config from '../../config/index';


//axios.defaults.baseURL = config.API_SERVER_BASE;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 60000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['companyId'] = 58; //融创58、粤海147、生产58
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
	// Do something before request is sent

	return config;
}, function (error) {
	// Do something with request error

	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
// Add a response interceptor
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
	// Do something with response data
	var code = response.data.status;
	if (code === 40002 || code === 40003 || code === 40005) {
		window.location.href = __WEBPACK_IMPORTED_MODULE_2__config_index__["b" /* LOGIN_URL */] + '/loginOut?url=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2__config_index__["a" /* RETURN_URL */] + "/jump-page");
		return;
	}
	// if (code === 401) {
	// 	var curhref = encodeURIComponent(window.location.href)
	// 	window.location.href = '/wechat/to-login?rurl=' + curhref
	// 	return;
	// }
	return response;
}, function (error) {
	// Do something with response error

	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export storage */
/* unused harmony export cookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateUtil; });
/* unused harmony export PageInfo */
/* unused harmony export Validator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/**
 * 存储localStorage
 */
var storage = {
	setLoc: function setLoc(name, content) {
		if (!name) return;
		if (typeof content !== 'string') {
			content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content);
		}
		window.localStorage.setItem(name, content);
	},

	/**
  * 获取localStorage
  */
	getLocal: function getLocal(name) {
		if (!name) return;
		return window.localStorage.getItem(name);
	},

	/**
  * 删除localStorage
  */
	removeLocal: function removeLocal(name) {
		if (!name) return;
		window.localStorage.removeItem(name);
	},
	/**
  * 存储sessionStorage
  */
	setSession: function setSession(name, content) {
		if (!name) return;
		if (typeof content !== 'string') {
			content = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(content);
		}
		window.sessionStorage.setItem(name, content);
	},

	/**
  * 获取sessionStorage
  */
	getSession: function getSession(name) {
		if (!name) return;
		return window.sessionStorage.getItem(name);
	},

	/**
  * 删除sessionStorage
  */
	removeSession: function removeSession(name) {
		if (!name) return;
		window.sessionStorage.removeItem(name);
	}
};

var cookie = {
	/**
  * 存cookie
  */
	setCookie: function setCookie(name, value) {
		var Days = 30;
		var exp = new Date();
		exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
		document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
	},

	/**
  * 取cookie
  */
	getCookie: function getCookie(name) {
		var arr,
		    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	},

	/**
  * 删所有cookie
  */
	clearCookie: function clearCookie() {
		var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
		if (keys) {
			for (var i = keys.length; i--;) {
				document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
			}
		}
	}
};

var DateUtil = {
	isLeapYear: function isLeapYear(date) {
		return date.getYear() % 4 === 0 && (date.getYear() % 100 !== 0 || date.getYear() % 400 === 0);
	},
	/**
  * 格式化日期
  */
	formatDate: function formatDate(date, fmt) {
		var yyyy = date.getFullYear();
		var MM = date.getMonth();
		var dd = date.getDate();
		var HH = date.getHours();
		var mm = date.getMinutes();
		var ss = date.getSeconds();
		var hh = HH > 12 ? HH - 12 : HH;
		var dateStr = fmt.replace('yyyy', yyyy).replace('MM', this.addZero(MM + 1)).replace('dd', this.addZero(dd)).replace('HH', this.addZero(HH)).replace('mm', this.addZero(mm)).replace('ss', this.addZero(ss)).replace('hh', this.addZero(hh));
		return dateStr;
	},

	addZero: function addZero(num) {
		if (num < 10) {
			return '0' + num;
		}
		return num;
	},

	/**
  * 将日期字符串转成日期 fmt：yyyy-MM-dd HH:mm:ss 或 yyyy-MM-dd
  */
	parseDate: function parseDate(str, fmt) {
		if (!str) {
			return null;
		}
		var date;
		var year = 0;
		var month = 0;
		var day = 0;
		var hour = 0;
		var minute = 0;
		var second = 0;
		var tempStrs = str.split(' ');
		if (tempStrs[0]) {
			var dateStrs = tempStrs[0].split("-");
			year = parseInt(dateStrs[0], 10);
			month = parseInt(dateStrs[1], 10) - 1;
			day = parseInt(dateStrs[2], 10);
		}
		if (tempStrs[1]) {
			var timeStrs = tempStrs[1].split(":");
			hour = parseInt(timeStrs[0], 10);
			minute = parseInt(timeStrs[1], 10);
			second = parseInt(timeStrs[2], 10);
		}

		if (fmt === 'yyyy-MM-dd') {
			date = new Date(year, month, day);
			return date;
		} else if (fmt === 'yyyy-MM-dd HH:mm:ss') {
			date = new Date(year, month, day, hour, minute, second);
			return date;
		}
		return null;
	},
	/**
  * 获取指定日期最后一天日期
  */
	getLastDate: function getLastDate(date) {
		date = arguments[0] || new Date();
		var newDate = new Date(date.getTime());
		newDate.setMonth(newDate.getMonth() + 1);
		newDate.setDate(1);
		var time = newDate.getTime() - 24 * 60 * 60 * 1000;
		newDate = new Date(time);
		return newDate;
	},
	/**
  * 获取日期差
  */
	getDateDiff: function getDateDiff(start, end) {
		return Math.round(Math.abs(start - end) / (1000 * 60 * 60 * 24));
	},
	/**
  * 获取指定日期第一天日期
  */
	getFirstDate: function getFirstDate(date) {
		date = arguments[0] || new Date();
		var newDate = new Date(date.getTime());
		newDate.setDate(1);
		return newDate;
	},
	/**
  * 获取周的第一天
  */
	getWeekStartDate: function getWeekStartDate(date) {
		date = arguments[0] || new Date();
		return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 1);
	},
	/**
  * 获取周的最后一天
  */
	getWeekEndDate: function getWeekEndDate(date) {
		date = arguments[0] || new Date();
		return new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - date.getDay() + 1));
	},
	/**
  * 日期计算
  *
  * @param strInterval
  *            string 可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
  * @param num
  *            int
  * @param date
  *            Date 日期对象
  * @return Date 返回日期对象
  */
	dateAdd: function dateAdd(strInterval, num, date) {
		date = arguments[2] || new Date();
		/* eslint-disable */
		switch (strInterval) {
			case 's':
				return new Date(date.getTime() + 1000 * num);
			case 'n':
				return new Date(date.getTime() + 60000 * num);
			case 'h':
				return new Date(date.getTime() + 3600000 * num);
			case 'd':
				return new Date(date.getTime() + 86400000 * num);
			case 'w':
				return new Date(date.getTime() + 86400000 * 7 * num);
			case 'm':
				return new Date(date.getFullYear(), date.getMonth() + num, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
			case 'y':
				return new Date(date.getFullYear() + num, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
		}
		/* eslint-enable */
	}
};

var PageInfo = {
	getPageInfo: function getPageInfo(pageInfo) {
		var total = pageInfo.dataCount || 0;
		var num = total % pageInfo.pageLimit;
		var totalPage = num === 0 ? total / pageInfo.pageLimit : Math.ceil(total / pageInfo.pageLimit);
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pageInfo, { totalPage: totalPage });
	}
};

var Validator = {
	isEmail: function isEmail(str) {
		if (str === '') {
			return true;
		}

		if (str.charAt(0) === "." || str.charAt(0) === "@" || str.indexOf('@', 0) === -1 || str.indexOf('.', 0) === -1 || str.lastIndexOf("@") === str.length - 1 || str.lastIndexOf(".") === str.length - 1) {
			return false;
		} else {
			return true;
		}
	},
	/**
  * 判断是否是日期
  */
	isDate: function isDate(date, fmt) {
		if (date === '') {
			return true;
		}
		if (fmt === null) {
			fmt = "yyyy-MM-dd";
		}
		var yIndex = fmt.indexOf("yyyy");
		if (yIndex === -1) {
			return false;
		}
		var year = date.substring(yIndex, yIndex + 4);
		var mIndex = fmt.indexOf("MM");
		if (mIndex === -1) {
			return false;
		}
		var month = date.substring(mIndex, mIndex + 2);
		var dIndex = fmt.indexOf("dd");
		if (dIndex === -1) {
			return false;
		}
		var day = date.substring(dIndex, dIndex + 2);
		if (!Validator.isNumber(year) || year > 2100 || year < 1900) {
			return false;
		}
		if (!Validator.isNumber(month) || month > 12 || month < 1) {
			return false;
		}
		if (day > Validator.getMaxDay(year, month) || day < 1) {
			return false;
		}
		return true;
	},

	/**
  * 检查输入字符串是否符合正整数格式
  *
  */
	isNumber: function isNumber(s) {
		if (s === '') {
			return true;
		}

		var regu = "^[0-9]+$";
		var re = new RegExp(regu);
		if (s.search(re) !== -1) {
			return true;
		} else {
			return false;
		}
	},

	/**
  * 检查输入字符串是否是带小数的数字格式,可以是负数
  *
  */
	isDecimal: function isDecimal(str) {

		if (Validator.isInteger(str)) {
			return true;
		}

		var re = /^[-]{0,1}(\d+)[\.]+(\d+)$/;
		if (re.test(str)) {

			if (RegExp.$1 === 0 && RegExp.$2 === 0) {
				return false;
			}

			return true;
		} else {
			return false;
		}
	},

	/**
  * 检查是否是Money
  *
  */
	isMoney: function isMoney(str) {
		if (str === '') {
			return true;
		}

		if (/^\d+($|\.\d+$)/.test(str)) {
			return true;
		} else {
			return false;
		}
	},
	/**
  * 校验字符串是否为整型
  *
  */
	isInteger: function isInteger(str) {
		if (str === '') {
			return true;
		}

		if (/^(\-?)(\d+)$/.test(str)) {
			return true;
		} else {
			return false;
		}
	},

	getPhoneType: function getPhoneType(phone) {
		var ltReg = /^1(3[0-2]|5[5|6]|8[5|6]|4[5]|7[5|6])\d{8}$|^170[7|8|9]\d{7}$/;

		var dxReg = /^1(3[3]|5[3]|7[3|7]|8[01]|8[9])\d{8}$|^170[0|1|2]\d{7}$/;

		var ydReg = /^1(3[4-9]|5[0-2]|5[4]|5[7-9]|7[8]|8[2|3|4|7|8]|4[7])\d{8}$|^170[3|5|6]\d{7}$/;

		var xlReg = /^0\d{2,3}\d{8}$/;

		if (ltReg.test(phone)) {
			return 1;
		}
		if (dxReg.test(phone)) {
			return 2;
		}
		if (ydReg.test(phone)) {
			return 3;
		}
		if (xlReg.test(phone)) {
			return 4;
		}

		return -1;
	},
	/**
  * 校验字符串是否为合法手机号码
  *
  */
	isPhone: function isPhone(str) {
		if (str === '') {
			return true;
		}
		if (Validator.getPhoneType(str) !== -1) {
			return true;
		} else {
			return false;
		}
	},

	/**
  * 检查输入字符串是否只由英文字母和数字和下划线组成
  *
  */
	isNumberOrLetter: function isNumberOrLetter(s) {

		var regu = "^[0-9a-zA-Z\_]+$";
		var re = new RegExp(regu);
		if (re.test(s)) {
			return true;
		} else {
			return false;
		}
	},

	/**
  * 检查输入字符串是否为空或者全部都是空格
  */
	isEmpty: function isEmpty(str) {
		if (str === "") {
			return true;
		}
		var regu = "^[ ]+$";
		var re = new RegExp(regu);
		return re.test(str);
	},

	/**
  * 判断是否是非法字符，即不含特殊字符
  *
  */
	isNormal: function isNormal(str) {
		if (str === '') {
			return true;
		}
		var reg = '~!#$%^&*()+{}|\'<>?`=[]/\。；;，,';
		for (var i = 0; i < reg.length; i++) {
			if (str.indexOf(reg.charAt(i)) !== -1) {
				return false;
			}
		}
		return true;
	},

	/**
  * 判断是否含有html字符
  *
  */
	isHtmlChar: function isHtmlChar(str) {
		if (str === '') {
			return true;
		}
		var reg = '&\'<>/\\';
		for (var i = 0; i < reg.length; i++) {
			if (str.indexOf(reg.charAt(i)) !== -1) {
				return true;
			}
		}
		return false;
	},

	/**
  * 判断是否是汉字
  *
  */
	isChinese: function isChinese(str) {
		if (str === '') {
			return true;
		}
		if (/[^\u4e00-\u9fa5]/.test(str)) {
			return false;
		} else {
			return true;
		}
	}
};

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

module.exports = {
	message: {
		title: 'English'
	}
};

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

module.exports = {
	message: {
		title: '中文'
	}
};

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var Home = function Home(resolve) {
	return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Test = function Test(resolve) {
	return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(633)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
	return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Invoice = function Invoice(resolve) {
	return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ChangePassword = function ChangePassword(resolve) {
	return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var CreditsExchange = function CreditsExchange(resolve) {
	return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var GiftCoupon = function GiftCoupon(resolve) {
	return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Information = function Information(resolve) {
	return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var MyGiftCoupon = function MyGiftCoupon(resolve) {
	return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Order = function Order(resolve) {
	return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PreviewAccount = function PreviewAccount(resolve) {
	return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(628)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var CouponDetail = function CouponDetail(resolve) {
	return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Member = function Member(resolve) {
	return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var BuyCard = function BuyCard(resolve) {
	return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var BookingList = function BookingList(resolve) {
	return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OrderForm = function OrderForm(resolve) {
	return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OrderSuccess = function OrderSuccess(resolve) {
	return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OrderDetail = function OrderDetail(resolve) {
	return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ModifyPhone = function ModifyPhone(resolve) {
	return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SearchHotel = function SearchHotel(resolve) {
	return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var JumpPage = function JumpPage(resolve) {
	return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OverTime = function OverTime(resolve) {
	return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(612)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Activity = function Activity(resolve) {
	return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Questions = function Questions(resolve) {
	return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(631)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var TimeOut = function TimeOut(resolve) {
	return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(632)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AnswerSuccess = function AnswerSuccess(resolve) {
	return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Invalid = function Invalid(resolve) {
	return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(630)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	base: "/pc/",
	mode: 'history',
	routes: [{
		path: '/login',
		name: 'login',
		component: Login
	}, {
		path: '/change-password',
		name: 'changePassword',
		component: ChangePassword,
		meta: {
			title: '修改密码'
		}
	}, {
		path: '/invoice',
		name: 'invoice',
		component: Invoice,
		meta: {
			title: '我的发票'
		}
	}, {
		path: '/credits-exchange',
		name: 'creditsExchange',
		component: CreditsExchange,
		meta: {
			title: '积分兑换'
		}
	}, {
		path: '/gift-coupon',
		name: 'giftCoupon',
		component: GiftCoupon,
		meta: {
			title: '礼券中心'
		}
	}, {
		path: '/information',
		name: 'information',
		component: Information,
		meta: {
			title: '个人资料完善'
		}
	}, {
		path: '/my-giftCoupon',
		name: 'myGiftCoupon',
		component: MyGiftCoupon,
		meta: {
			title: '我的礼券'
		}
	}, {
		path: '/order',
		name: 'order',
		component: Order,
		meta: {
			title: '我的订单'
		}
	}, {
		path: '/preview-account',
		name: 'previewAccount',
		component: PreviewAccount,
		meta: {
			title: '账户预览'
		}
	}, {
		path: '/coupon-detail',
		name: 'couponDetail',
		component: CouponDetail,
		meta: {
			title: '礼券详情'
		}
	}, {
		path: '/member',
		name: 'member',
		component: Member,
		meta: {
			title: '会员权益'
		}
	}, {
		path: '/buy-card',
		name: 'buyCard',
		component: BuyCard,
		meta: {
			title: '购买会员卡'
		}
	}, {
		path: '/modify-phone',
		name: 'modifyPhone',
		component: ModifyPhone,
		meta: {
			title: '更换手机号'
		}
	},

	// **********************以上去除会员中心***************************************

	{
		path: '/',
		name: 'searchHotel',
		component: SearchHotel,
		meta: {
			title: '查询酒店'
		}
	}, {
		path: '/test',
		name: 'test',
		component: Test,
		meta: {
			title: ''
		}
	}, {
		path: '/booking-list',
		name: 'bookingList',
		component: BookingList,
		meta: {
			title: '房型列表'
		}
	}, {
		path: '/order-form',
		name: 'orderForm',
		component: OrderForm,
		meta: {
			title: '预订表单'
		}
	}, {
		path: '/order-success',
		name: 'orderSuccess',
		component: OrderSuccess,
		meta: {
			title: '订单完成'
		}
	}, {
		path: '/order-detail',
		name: 'orderDetail',
		component: OrderDetail,
		meta: {
			title: '订单详情'
		}
	}, {
		path: '/search-hotel',
		name: 'searchHotel',
		component: SearchHotel,
		meta: {
			title: '查询酒店'
		}
	}, {
		path: '/jump-page',
		name: 'jumpPage',
		component: JumpPage
	}, {
		path: '/over-time',
		name: 'overTime',
		component: OverTime
	}, {
		path: '/activity',
		name: 'activity',
		component: Activity
	},
	// 以下是问卷............................................................................
	{
		path: '/questions',
		name: 'questions',
		component: Questions,
		meta: {
			title: '问卷调查'
		}
	}, {
		path: '/time-out',
		component: TimeOut,
		meta: {
			title: '问卷调查'
		}
	}, {
		path: '/answer-success',
		component: AnswerSuccess,
		meta: {
			title: '问卷调查'
		}
	}, {
		path: '/invalid',
		component: Invalid,
		meta: {
			title: '问卷调查'
		}
	}]
});

router.afterEach(function (route) {
	window.scrollTo(0, 0);
	if (route.meta.title) {
		document.title = route.meta.title;
	}
	if (route.path == "/preview-account" || route.path == "/information" || route.path == "/invoice" || route.path == "/jump-page") {
		if (localStorage.userJwtToken == undefined) {
			var userJwtToken = getQueryString("userJwtToken");
		} else {
			var userJwtToken = localStorage.userJwtToken;
		}
		localStorage.userJwtToken = userJwtToken;
		getTicket(userJwtToken);
		// getAccessToken();
	}
});

router.beforeEach(function (to, from, next) {
	// if (_hmt) {
	// 	if (to.path) {
	// 		_hmt.push(['_trackPageview', '/#' + to.fullPath]);
	// 	}
	// }
	getAccessToken();
	setTimeout(function () {
		next();
	}, 500);
});

//query.params
function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return unescape(r[2]);
	}
	return null;
}

function getTicket(userJwtToken) {
	__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/gk/api/token/getTicket?userJwtToken=" + userJwtToken, {}, __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$token).then(function (res) {
		if (res.data.status == 200) {
			getUserToken(res.data.data.userTicket);
		}
	}).catch(function (error) {
		console.log(error);
	});
}

function getToKen() {
	if (localStorage.accessToken != undefined || localStorage.accessToken != '') {
		__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$token = {
			headers: {
				'accessToken': localStorage.accessToken,
				'userToken': localStorage.userToken
			}
		};
	} else {
		this.getAccessToken();
	}
}

function getAccessToken() {
	__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/gu/api/v1/hub/auth/getAccessToken").then(function (res) {
		localStorage.accessToken = res.data.data.accessToken;
		__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$token = {
			headers: {
				'accessToken': res.data.data.accessToken,
				'userToken': localStorage.userToken
			}
		};
		getTicket(getQueryString("userJwtToken"));
	}).catch(function (error) {
		console.log(error);
	});
}

function getUserToken(params) {
	__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/gk/api/token/getUserToken?ticket=" + params, {}, __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$token).then(function (res) {
		__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$token = {
			headers: {
				'accessToken': localStorage.accessToken,
				'userToken': res.data.data.userToken
			}
		};
		localStorage.userToken = res.data.data.userToken;
		sessionStorage.memberId = res.data.data.memberInfo.memberId;
		sessionStorage.memberLevelId = res.data.data.memberInfo.memberLevelId;
		sessionStorage.memberInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.memberInfo);
	}).catch(function (error) {
		console.log(error);
	});
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(601);
/**
 * Created by YECHENGYOU on 2018/8/1.
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		cartList: []
	},
	getters: {},
	mutations: {
		addCart: function addCart(state, info) {
			var isAdded = state.cartList.find(function (item) {
				return item.id === info.id;
			});
			if (isAdded) {
				isAdded.count++;
			} else {
				state.cartList.push({
					id: info.id,
					count: 1,
					info: info
				});
			}
		},
		editCartCount: function editCartCount(state, info) {
			var isDeled = state.cartList.find(function (item) {
				return item.id === info.id;
			});
			if (isDeled.count > 0) {
				isDeled.count--;
			}
			if (isDeled.count == 0) {
				var index = state.cartList.findIndex(function (item) {
					return item.id === info.id;
				});
				state.cartList.splice(index, 1);
			}
		},
		deleteCart: function deleteCart(state, info) {
			var index = state.cartList.findIndex(function (item) {
				return item.id === info.id;
			});
			state.cartList.splice(index, 1);
		},
		emptyCart: function emptyCart(state) {
			state.cartList = [];
		}
	},
	actions: {}
}));

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/beian.d0289dc.png";

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gdhmlogo.c4f73c7.png";

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var Component = __webpack_require__(103)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(597),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var Component = __webpack_require__(103)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-98548a84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(103)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51feea30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HeaderTY-cmp"
  }, [_c('div', {
    staticClass: "header-pc clearfix hidden-xs hidden-sm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-right-pc clearfix"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.searchHotel
    }
  }, [_vm._v("查找酒店")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": this.$LoginUrl + '/?url=' + this.$ReturnUrl + '/jump-page'
    }
  }, [_vm._v("粤海荟")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "30px"
    }
  }, [_c('span', {
    staticClass: "leftLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "tabLanguage",
    on: {
      "click": function($event) {
        _vm.showLanguage = !_vm.showLanguage
      }
    }
  }, [_vm._v("语言")]), _vm._v(" "), _c('el-collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLanguage),
      expression: "showLanguage"
    }],
    staticClass: "yuyanTab"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.ZNurl
    }
  }, [_vm._v("简体中文")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.ENurl
    }
  }, [_vm._v("English")])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(591)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com"
    }
  }, [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/conference_banquet/conference_banquet.html"
    }
  }, [_vm._v("会议与宴会")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/group-introduction.html"
    }
  }, [_vm._v("集团介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://booking.gdhhotels.com/auth/?url=http://booking.gdhhotels.com/pc/jump-page?from=order"
    }
  }, [_vm._v("我的订单")])])
}]}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.headerShow) ? _c('Header') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.headerShow) ? _c('Footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FooterTY-cmp"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "edit-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "city-links"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("城市分布")]), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, _vm._l((_vm.hotelList), function(data, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": _vm.hostUrl + '/pc/search-hotel?hotelId=' + data.code
      }
    }, [_vm._v(_vm._s(data.name))])
  }), 0)])])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(590)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "links clearfix"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/hotel-alliance.html"
    }
  }, [_vm._v("业务拓展")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/join-us1.html"
    }
  }, [_vm._v("人才招聘")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "edit-container"
  }, [_c('div', {
    staticClass: "links"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/usage.html"
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/privacy.html"
    }
  }, [_vm._v("隐私声明")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/contact-us.html"
    }
  }, [_vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('span', [_vm._v("版权所有 粤海国际酒店管理（中国）有限公司")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("ICP备案号 粤ICP备06050136号")])]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302002010"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(589)
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t粤公网安备 44030302002010号\n\t\t\t\t\t\t\t")])])])])])
}]}

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
module.exports = __webpack_require__(234);


/***/ })

},[603]);


// WEBPACK FOOTER //
// static/js/app.66c9e61d91ef8e5dba61.js